import React from 'react';
import './header-component.scss';
import { Constants, ImageConstants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import { Link, Redirect } from 'react-router-dom';
import Path from '../../routes/routes-path';
import Loading from '../../common/loading/loading';
// import Service from '../../../apis/service-manager';
// import Urls from '../../../apis/url';
import SessionCache from '../../routes/session-cache';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRetweet, faBars, faTimes } from '@fortawesome/free-solid-svg-icons'
// import RewardApi from '../../../apis/rewards'
import Store from '../../../store/store';
import CommonUtils from '../../../utility/common-utilities';
import SharedProfile from '../../../../shared-storage/profile';
import AuthenticateAPI from '../../../apis/authenticate';
import SubjectSelectionShared from '../../../../shared-storage/subject-selection-shared';
import LayoutShared from '../layout-shared/layout-shared';
import ReactTooltip from "react-tooltip";

class Header extends React.Component {

    state = {
        isLogout: false,
        isLoading: false,
        userInfo: {},
        isListening: false,
        goToHomeScreen: false,
        isDesktop: window.innerWidth > 991
    };

    constructor(props) {
        super(props);
        this.subjectionSelection = SubjectSelectionShared.getSubjectSelection()
    }

    componentDidMount() {
        let userInfo = SharedProfile.getProfile()
        this.setState({ userInfo })
        // this.getReward()
        Store.setStore("headerComponent", this)
        this.layoutShared = LayoutShared.getLayout()
        window.addEventListener('resize', this.updatePredicate);
        ReactTooltip.rebuild()
    }

    // getReward(payload = {}) {
    //     RewardApi.getRewardPoints(payload)
    //         .then(response => {
    //             let reward = response.response
    //             this.setState({ reward: reward, isLoading: false })
    //         }).catch(err => {
    //             this.setState({ isLoading: false })
    //         })
    // }

    handleStartListening = () => {
        // const { isListening } = this.state;

        // if (isListening) {
        //     this.setState({ isListening: false });
        //     window.electron.remoteControl.unsubscribeEvents();
        //     window.electron.remoteControl.close();
        // } else {
        //     this.setState({ isListening: true });
        //     console.log('Opening remote control', window.electron.remoteControl.open);
        //     window.electron.remoteControl.open();

        //     window.electron.remoteControl.subscribeEvents((data) => {
        //         console.log('Received data:', data);
        //     });
        // }
        // window.electron.ipcRenderer.once('ipc-example', (arg) => {
        //     // eslint-disable-next-line no-console
        //     console.log(arg);
        // });
        // window.electron.ipcRenderer.send('ipc-example', ['ping']);

        // window.electron.ipcRenderer.send('toggle-fullscreen', ['ping']);


    };

    componentWillUnmount() {
        // Cleanup on component unmount
        // window.electron.remoteControl.unsubscribeEvents();
        // window.electron.remoteControl.close();
        window.removeEventListener('resize', this.updatePredicate);
    }

    updatePredicate = () => {
        this.setState({ isDesktop: window.innerWidth > 991 });
    }


    logout = () => {

        this.props.delegate && this.props.delegate.logout()

        // this.setState({
        //     isLoading: true
        // });

        // AuthenticateAPI.studentLogout().then((res) => {

        //     SharedProfile.setProfile({
        //         isAuthenticated: false
        //     });

        //     this.setState({
        //         isLoading: false,
        //     });

        //     setTimeout(() => {
        //         this.setState({
        //             isLogout: true,
        //         });
        //     }, 200);

        // }).catch(err => {
        //     //console.log(err)
        // })
    }

    goToHomeScreen() {
        return this.props?.delegate?.props?.history?.push({ pathname: Path.HOME })
    }

    showSubjectSelection() {
        this.layoutShared.showSubjectSelection()
        // console.log(this.subjectionSelection)
        // window.location.reload();
        // return this.props?.delegate?.props?.history?.push({ pathname: Path.HOME, state: { showSubjectSelection: true, key: Date.now() } })
    }

    goToHome() {
        // this.setState({goToHomeScreen : true})
        window.location.reload()
    }

    toggleMobileSidebar = () => {
        if (this.props.delegate && this.props.delegate.toggleSidebar) {
            this.props.delegate.toggleSidebar();
        } else if (this.layoutShared && this.layoutShared.toggleSidebar) {
            this.layoutShared.toggleSidebar();
        }
    }


    render() {

        const { isListening } = this.state;
        const isSidebarOpen = this.props.delegate ? !this.props.delegate.state.hideSideBar : false;

        return (
            <div className={`cw-header ${this.state.isDesktop ? '' : 'cw-header-responsive'} row no-gutters header-bg ${this.props.transparent ? '' : ''}`}
                style={{ display: `${this.props.showHideHeader ? "" : "none"}` }} onMouseEnter={ReactTooltip.rebuild}>
                {this.state.isLoading && <Loading></Loading>}
                {this.state.isLogout && <Redirect to={Path.LOGIN} />}

                <div className="col-auto logo-container">
                    <button
                        type="button"
                        className="mobile-hamburger-btn cursor-pointer"
                        onClick={this.toggleMobileSidebar}
                        aria-label={isSidebarOpen ? "Close navigation menu" : "Open navigation menu"}
                    >
                        <FontAwesomeIcon icon={isSidebarOpen ? faTimes : faBars} />
                    </button>
                    <div className='cursor-pointer' onClick={() => this.goToHome()}>
                        <img className="logo" src={getImageSource(ImageConstants.CW_LOGO)} />
                    </div>
                </div>
                <div className="col header-right-container">
                    {/* <Link to={`${Path.PROFILE}?type=reward`}>
                        <div className="d-inline-block reward-wrapper mr-4">
                            <img alt="" src={getImageSource(ImageConstants.GIFTBOX)} className='mr-2' />
                            <span className="reward-text mr-2">My Reward Points</span> <span className="reward-point"> {CommonUtils.convertToFixed(this.state.reward?.availablePoints || 0, 2)}</span>
                        </div>
                    </Link> */}
                    {/* <div>
                        <p>{isListening ? 'Listening...' : 'Not listening'}</p>
                        <button onClick={this.handleStartListening}>
                            Toggle Listening
                        </button>
                    </div> */}
                    <div className='header-user-profile d-flex align-items-center'>
                        <img className='user-name-icon-size' src={getImageSource(ImageConstants.USER_NAME_ICON)} />
                        <div className='user-name-text'>{this.state.userInfo.name}</div>
                    </div>


                    {!this.props.from || this.props.from != 'VERIFY_SCREEN' ?
                        <><div className='school-container home-icon-container'>
                            {/* <div className='text-right'><span className='school-name'>{this.state?.userInfo?.name || ""}</span></div> */}
                            {/* <div className='text-right school-address'>{this.state?.userInfo?.schoolInfo?.address?.branch || ""}, {this.state?.userInfo?.schoolInfo?.address?.city || ""}</div> */}
                            <div className=''>
                                <img className='home-icon main-home-icon cursor-pointer' onClick={() => this.goToHomeScreen()}
                                    src={getImageSource(ImageConstants.HOME_ICON)} />
                            </div>
                        </div>
                            <div className='school-container header-merits-container'>
                                <Link to={Path.MY_MERITS}>
                                    <img className='home-icon cup-icon cursor-pointer'
                                        src={getImageSource(ImageConstants.CUP_ICON)}
                                        data-tip={'My Merits'} />
                                </Link>
                            </div>
                            {
                                this.state.userInfo?.isSuperAdmin ?
                                    <div className='school-container'>
                                        <div className='text-right'>
                                            <Link to={Path.SCHOOLS}>
                                                <FontAwesomeIcon className="cursor-pointer" icon={faRetweet} />
                                            </Link>
                                        </div>
                                    </div> : ""
                            }
                            {/* <div className='school-container'>
                            <div className='text-right'><small>UNIQUE SCHOOL CODE :</small> <span className='school-name'>{this.state?.userInfo?.schoolInfo?.schoolCode || ""}</span></div>
                        </div> */}

                            <div className='bell-icon-container'>
                                <img className='bell-icon' src={getImageSource(ImageConstants.NOTIFICATION_BELL_ACTIVE)}></img>
                            </div>
                        </> : ''}

                    {
                        ['Class 9', 'Class 10', 'Class 11', 'Class 12'].includes(this.state.userInfo.class) ?
                            <div className='subject-change-container'>
                                <img className='bell-icon cursor-pointer subject-change-icon'
                                    data-tip={'Change Subject'}
                                    onClick={() => this.showSubjectSelection()}
                                    src={getImageSource(ImageConstants.SUBJECT_CHANGE_ICON)}></img>
                            </div>
                            :
                            <></>
                    }



                    {this.props.from && this.props.from == 'VERIFY_SCREEN' ? <span className='pr-2 logout-text'>Logout</span> : ''}

                    <div className='logout-button-wrapper cursor-pointer' onClick={this.logout}>
                        <div className='logout-text'>LOGOUT</div>
                        <div><img className="logout-icon pt-2 pb-2" src={getImageSource(ImageConstants.LOGOUT_ICON_RED)} ></img></div>
                    </div>
                </div>
                <ReactTooltip className="border arrow" arrowColor="#C4C4C4" ref={el => this.tooltip = el}
                    multiline={true}
                    place='bottom'
                    type='light' effect='solid'
                    event="mouseover mouseenter"
                    eventOff="mouseleave mouseout scroll mousewheel blur" />
            </div>
        );
    }
}

export default Header;